// Generated by CoffeeScript 2.7.0
var CascadedSelectsList, cascaded_select_node_comp, cascaded_select_tree_comp;

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import EditCascadedSelectChoiceModal from '../cascaded_selects_modal/edit_cascaded_select_choice_modal.js';

import EditCascadedSelectChoicesModal from '../cascaded_selects_modal/edit_cascaded_select_choices_modal.js';

cascaded_select_node_comp = Vue.extend({
  name: 'cascaded-select-node',
  props: {
    node: {
      type: Object
    },
    maxLabelLength: {
      type: Number
    },
    initialCascadedSelectId: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      expanded: false
    };
  },
  computed: {
    level: function() {
      return this.node.path.length;
    },
    nodeClass: function() {
      return {
        expanded: this.expanded
      };
    },
    expandedText: function() {
      if (this.expanded) {
        return '收起';
      } else {
        return '展开';
      }
    },
    canAddNode: function() {
      return this.level < this.maxLabelLength;
    },
    nodeIndent: function() {
      return `${(this.level - 1) * 1.6}rem`;
    }
  },
  template: `<div class="cascaded-select-node"
     :class='nodeClass'>
  <div class='node-wrapper justify-between'>
    <div class='node-name text-ellipsis'
         :style="{ paddingLeft: nodeIndent }">
      <span>{{ node.name }}</span>
    </div>
    <div class="pull-right">
      <button v-if="!node.isLeaf"
              class="expanded-text text-btn btn-primary"
              @click.stop="toggleExpand">{{ expandedText }}</button>
      <button :disabled="!canAddNode"
              class="text-btn btn-primary"
              @click="openAddNewChoiceFunc">新增下级</button>
      <button :disabled="!canAddNode"
              class="text-btn btn-primary"
              @click="openAddNewChoicesFunc">批量新增下级</button>
      <button class="text-btn btn-primary"
              @click="openEditChoiceFunc">编辑</button>
      <button :disabled="node.locked"
              class="text-btn btn-danger"
              @click="deleteChoiceFunc">删除</button>
    </div>
  </div>
  <div class='node-children'>
    <cascaded-select-node
      v-for='child in node.children'
      :key='child.id'
      :node='child'
      :maxLabelLength="maxLabelLength"
      :initialCascadedSelectId="initialCascadedSelectId"
      @choiceDeleted="choiceDeletedFunc"
      ref='children' />
  </div>
</div>`,
  methods: {
    toggleExpand: function() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        return this._fetchChildren();
      }
    },
    openAddNewChoiceFunc: function() {
      return new EditCascadedSelectChoiceModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-cascaded-select-choice-modal'),
        propsData: {
          cascadedSelectId: this.initialCascadedSelectId,
          title: '新增下级',
          parentId: this.node.id,
          callback: (data) => {
            this.node.children_count += 1;
            return this._fetchChildren();
          }
        }
      });
    },
    openAddNewChoicesFunc: function() {
      return new EditCascadedSelectChoicesModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-cascaded-select-choices-modal'),
        propsData: {
          title: '批量新增下级',
          cascadedSelectId: this.initialCascadedSelectId,
          parentId: this.node.id,
          callback: (data) => {
            this.node.children_count += data.length;
            return this._fetchChildren();
          }
        }
      });
    },
    openEditChoiceFunc: function() {
      return new EditCascadedSelectChoiceModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-cascaded-select-choice-modal'),
        propsData: {
          title: '编辑选项',
          parentId: this.node.parent_id,
          node: this.node,
          callback: (data) => {
            return this.node.name = data.name;
          }
        }
      });
    },
    deleteChoiceFunc: function() {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '是否删除此选项',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.delete(`/admin/choices/${this.node.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: () => {
            Skylark.Bridge.newAlertify('删除级联选择成功', {
              type: 'success'
            });
            return this.$emit('choiceDeleted', this.node);
          },
          error: function() {
            return Skylark.Bridge.newAlertify('删除级联选择失败', {
              type: 'error'
            });
          }
        });
      });
    },
    choiceDeletedFunc: function(choice) {
      return this.$emit('choiceDeleted', choice);
    },
    _fetchChildren: function() {
      if (this.node.children_count === 0) {
        return;
      }
      if (this.node.children_count === this.node.children.length) {
        return;
      }
      return Skylark.Libs.Ajax.get(`${this.node.hierarchy.resources}/${this.node.id}/children`, {
        responseType: 'json',
        success: (rawNodes) => {
          // reset(correct) children_count if children are blank
          if (_.isBlank(rawNodes)) {
            return this.node.children_count = 0;
          } else {
            this.node.children_count = rawNodes.length;
            return this.node.hierarchy.addNodes(rawNodes);
          }
        }
      });
    }
  }
});

cascaded_select_tree_comp = Vue.extend({
  components: {
    'cascaded-select-node': cascaded_select_node_comp
  },
  props: {
    tree: {
      type: Object
    },
    maxLabelLength: {
      type: Number
    },
    initialCascadedSelectId: {
      type: Number,
      required: true
    }
  },
  template: `<div class="cascaded-select-tree">
  <cascaded-select-node :node="tree.root"
                        :maxLabelLength="maxLabelLength"
                        :initialCascadedSelectId="initialCascadedSelectId"
                        @choiceDeleted="choiceDeletedFunc"
                        ref='root'/>
</div>`,
  methods: {
    choiceDeletedFunc: function(choice) {
      return this.$emit('choiceDeleted', choice);
    }
  }
});

export default CascadedSelectsList = Vue.extend({
  components: {
    'cascaded-select-tree': cascaded_select_tree_comp
  },
  props: {
    resourceUrl: {
      type: String,
      default: '/cascaded_selects'
    },
    initialCascadedSelectId: {
      type: Number,
      required: true
    },
    maxLabelLength: {
      type: Number
    }
  },
  template: `<div class="cascaded-select-list">
  <div class="cascaded-select-tree-container">
    <cascaded-select-tree v-for="tree in hierarchy.trees"
                          :tree="tree"
                          :key="tree.root.id"
                          :maxLabelLength="maxLabelLength"
                          :initialCascadedSelectId="initialCascadedSelectId"
                          @choiceDeleted="choiceDeletedFunc"
                          ref='trees' />
    <div  v-if="hierarchy.trees.length == 0"
          class="no-data">暂无数据</div>
  </div>
</div>`,
  data: function() {
    return {
      hierarchy: new Skylark.Libs.Hierarchy()
    };
  },
  created: function() {
    this.hierarchy.resources = this.getChoicesUrl;
    return this._initHierarchy();
  },
  computed: {
    getChoicesUrl: function() {
      return `${this.resourceUrl}/${this.initialCascadedSelectId}/choices`;
    }
  },
  methods: {
    choiceDeletedFunc: function(choice) {
      return this.hierarchy.removeNode(choice);
    },
    _initHierarchy: function() {
      return Skylark.Libs.Ajax.get(this.getChoicesUrl, {
        responseType: 'json',
        success: (data) => {
          return this.hierarchy.addNodes(data.data);
        }
      });
    }
  }
});
